window.tableRowClick = function(e, link) {
    var tagName = e.target.tagName;
    var className = e.target.className.trim();

    // console.log("YES 0------------")
    // console.log(e.target.tagName)
    // console.log(e.target.className)

    if (className != "myicon") {
      if (tagName == "DIV" || tagName == "TD" || tagName == "TR" || tagName == "P" || tagName == "IMG" || tagName == "SPAN") {
        Turbo.visit(link)
      }
    }

}

window.tableTurboRowClick = function(e, link) {
    var tagName = e.target.tagName;
    var className = e.target.className.trim();

    // Get the clicked element's job ID - check parent elements if needed
    let clickedElement = e.target;
    let dataJobId = clickedElement.dataset.jobid;
    
    // If clicked element doesn't have jobid, traverse up to find the article/tr with jobid
    while (!dataJobId && clickedElement.parentElement) {
      clickedElement = clickedElement.parentElement;
      dataJobId = clickedElement.dataset.jobid;
    }
    
    if (!dataJobId) return; // Early exit if no job ID found
    
    var trElement = document.querySelector(`tr[data-jobid="${dataJobId}"], article[data-jobid="${dataJobId}"]`);
    if (!trElement) return; // Early exit if element not found

    // PERFORMANCE: Debounce - Prevent multiple rapid clicks
    if (trElement.dataset.clicking === 'true') {
      console.log('Debounced click - already loading');
      return;
    }

    // PERFORMANCE: Only remove selection from previously selected element (avoid querySelectorAll)
    var previouslySelected = document.querySelector('.selected-tr');
    if (previouslySelected && previouslySelected !== trElement) {
      previouslySelected.classList.remove('selected-tr', 'clicking');
      previouslySelected.dataset.clicking = 'false';
    }

    if (className != "myicon") {

      if (e.metaKey) {
        window.open(link, '_blank').focus();
        return; // Don't load in frame if opening in new tab
      }

      if (tagName == "DIV" || tagName == "TD" || tagName == "TR" || tagName == "P" || tagName == "IMG" || tagName == "SPAN" || tagName == "H2" || tagName == "H3" || tagName == "ARTICLE") {
        // Immediate visual feedback - add classes BEFORE any loading starts
        trElement.classList.add("clicking", "selected-tr");
        trElement.dataset.clicking = 'true';
        
        // PERFORMANCE: Use CSS class instead of inline style manipulation
        trElement.classList.add('job-card-active');

        let frame = document.querySelector('turbo-frame#job');
        
        // PERFORMANCE: Optimized loading indicator
        if (frame) {
          frame.classList.add('loading');
          
          // PERFORMANCE: Simpler skeleton HTML (less DOM manipulation)
          frame.innerHTML = '<div class="job-skeleton-loader"><div class="skeleton-header"></div><div class="skeleton-body"></div></div>';
          
          // Set the source URL to trigger Turbo frame load
          frame.src = link;
          
          // PERFORMANCE: Single event handler with cleanup
          const cleanup = () => {
            frame.classList.remove('loading');
            trElement.dataset.clicking = 'false';
            trElement.classList.remove('job-card-active');
          };
          
          // Handle successful load
          frame.addEventListener('turbo:frame-load', cleanup, { once: true });
          
          // Handle errors
          frame.addEventListener('turbo:frame-missing', () => {
            cleanup();
            trElement.classList.remove('clicking');
            console.error('Failed to load job details');
          }, { once: true });
          
          // Timeout fallback (5 seconds)
          setTimeout(() => {
            if (frame.classList.contains('loading')) {
              cleanup();
              trElement.classList.remove('clicking');
            }
          }, 5000);
        }
      }
    }

}

window.tableTurboRowClickBanner = function(e, link) {
    var tagName = e.target.tagName;
    var className = e.target.className.trim();

    if (className != "myicon") {

      // if (e.metaKey) {
      //   window.open(link, '_blank').focus();
      // }

      if (tagName == "DIV" || tagName == "TD" || tagName == "TR" || tagName == "P" || tagName == "IMG" || tagName == "SPAN" || tagName == "H2" || tagName == "H3" || tagName == "IMG" || tagName == "A") {
        // history.replaceState({}, link, link);
        window.location.href = link;
      }
    }

}

window.spanTagsClick = function(e, link) {
    if (!link) return;

    // Make tag pills reliably clickable (many are <button> with nested elements).
    // Also prevent Turbo Frame navigation so we always land on a full page
    // (header/footer intact).
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    const target = e?.target;
    const className = (target && typeof target.className === "string") ? target.className.trim() : "";

    // Ignore clicks on icons (favorite, etc.)
    if (className === "myicon") return;

    // Allow cmd/ctrl click to open in new tab
    if (e && (e.metaKey || e.ctrlKey)) {
      window.open(link, "_blank", "noopener,noreferrer");
      return;
    }

    if (window.Turbo && typeof window.Turbo.visit === "function") {
      window.Turbo.visit(link, { action: "advance" });
    } else {
      window.location.href = link;
    }
}
